module.exports = __webpack_public_path__ + "img/game8.e2478ebb.png";